<template>
  <div v-if="!tabLoading" class="grid grid--rev">
    <div class="grid__cell col5-of-12--large-up"></div>
    <div class="grid__cell col7-of-12--large-up">
      <p class="fw-bold fs-md mb-sm">URL Configuration</p>
      <div class="grid">
        <Form
          @url-change="urlChange"
          :data="urls"
          :urlIntRequestButtonActive="urlIntRequestButtonActive"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/components/Dashboard/SettingsURLsForm';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/urls');

export default {
  components: {
    Form,
  },
  computed: {
    ...mapGetters(['urls', 'urlIntRequestButtonActive']),
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  methods: {
    ...mapActions(['fetchUrls', 'urlChange']),
  },
  created() {
    //this.fetchUrls();
  },
};
</script>
